export const isProd =
  process.env.REACT_APP_ENV?.toLowerCase?.()?.startsWith?.("prod");

export const mainAPIUrl = process.env.REACT_APP_MAIN_API;

export const userAPIUrl = process.env.REACT_APP_USER_API;

export const gestureWebsiteUrl = process.env.REACT_APP_GESTURE_WEBSITE_URL;

export const redirectAllowlist = (
  process.env.REACT_APP_REDIRECT_ALLOW_LIST || ""
)
  .split(",")
  .map((d) => d.trim())
  .filter(Boolean);
